import React, { Suspense, useEffect, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './contexts/LanguageContext';
import { Layout } from './components/layout/Layout';
import './App.css';

// Lazy-loaded pages for code splitting
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Leadership = lazy(() => import('./pages/Leadership'));
const VisionMission = lazy(() => import('./pages/VisionMission'));
const Products = lazy(() => import('./pages/Products'));
const BusinessModel = lazy(() => import('./pages/BusinessModel'));
const GlobalOperations = lazy(() => import('./pages/GlobalOperations'));
const CorporateStructure = lazy(() => import('./pages/CorporateStructure'));
const Compliance = lazy(() => import('./pages/Compliance'));
const Brochures = lazy(() => import('./pages/Brochures'));
const Contact = lazy(() => import('./pages/Contact'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const Terms = lazy(() => import('./pages/Terms'));
const CookiePolicy = lazy(() => import('./pages/CookiePolicy'));
const FDADisclaimer = lazy(() => import('./pages/FDADisclaimer'));
const RefundPolicy = lazy(() => import('./pages/RefundPolicy'));
const ShippingPolicy = lazy(() => import('./pages/ShippingPolicy'));
const IncomeDisclosure = lazy(() => import('./pages/IncomeDisclosure'));
const Admin = lazy(() => import('./pages/Admin'));

// Loading fallback
const PageLoader = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-[#001f54] border-t-transparent rounded-full animate-spin" />
  </div>
);

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <Router>
          <ScrollToTop />
          <Layout>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/leadership" element={<Leadership />} />
                <Route path="/vision" element={<VisionMission />} />
                <Route path="/products" element={<Products />} />
                <Route path="/business-model" element={<BusinessModel />} />
                <Route path="/operations" element={<GlobalOperations />} />
                <Route path="/structure" element={<CorporateStructure />} />
                <Route path="/compliance" element={<Compliance />} />
                <Route path="/brochures" element={<Brochures />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/cookies" element={<CookiePolicy />} />
                <Route path="/fda-disclaimer" element={<FDADisclaimer />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
                <Route path="/shipping-policy" element={<ShippingPolicy />} />
                <Route path="/income-disclosure" element={<IncomeDisclosure />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </Suspense>
          </Layout>
        </Router>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
